import React from 'react';

export const EMAIL_WORKSPACE_INPUT = 'EMAIL_INPUT';
export const TENANT_SELECTION = 'TENANT_SELECTION';
export const PASSWORD_INPUT = 'PASSWORD_INPUT';
export const MFA_CODE_MISSING = 'MFA_CODE_MISSING';
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED';
export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const RECOVER_PASSWORD_SUCCESS = 'RECOVER_PASSWORD_SUCCESS';
export const RECOVER_PASSWORD_WITH_CODE = 'RECOVER_PASSWORD_WITH_CODE';

export type LoginStepType =
  | typeof EMAIL_WORKSPACE_INPUT
  | typeof TENANT_SELECTION
  | typeof PASSWORD_INPUT
  | typeof MFA_CODE_MISSING
  | typeof NEW_PASSWORD_REQUIRED
  | typeof MFA_SETUP_REQUIRED
  | typeof RECOVER_PASSWORD
  | typeof RECOVER_PASSWORD_SUCCESS
  | typeof RECOVER_PASSWORD_WITH_CODE;

type SSOProviders = {
  name: string;
  createdAt: string;
  type: string;
  updatedAt: string;
};

export type SSOConfig = {
  callbackUrl: string;
  clientId: string;
  region: string;
  providers: SSOProviders[];
  domain: string;
  tenant: string;
};

export type TenantWithSubdomain = { tenant: string; subdomain: string }

export interface ContextInterface {
  step: LoginStepType;
  setStep: React.Dispatch<React.SetStateAction<LoginStepType>>;
  ssoConfig: SSOConfig | false;
  setSsoConfig: React.Dispatch<React.SetStateAction<SSOConfig | false>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  workspace: string;
  setWorkspace: React.Dispatch<React.SetStateAction<string>>;
  workspaceExpanded: boolean;
  setWorkspaceExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  tenantList: TenantWithSubdomain[];
  setTenantList: React.Dispatch<React.SetStateAction<TenantWithSubdomain[]>>;
}

export interface CheckSSOResponse {
  ssoConfig: SSOConfig | false;
}

export interface FetchTenantListResponse {
  tenantList: string[];
  tenantListWithSubdomain: { tenant: string; subdomain: string }[]
}

export type UserResponseObj = {
  name: string;
  email: string;
  roles: string[];
  permissions: string[];
  envName?: string;
  tenant?: string;
};

export type AuthenticateResponseInterface = {
  accessToken: string;
  envName: string;
  subdomain: string;
  message: string;
  tenant: string;
  user: UserResponseObj;
};

export interface CheckSSOPayload {
  email: string;
  tenant?: string;
}

export interface AuthenticatePayload extends CheckSSOPayload {
  password: string;
}

export interface AuthenticateMFAPayload extends AuthenticatePayload {
  mfaCode: string;
}

export interface AuthenticatePasswordPayload extends AuthenticatePayload {
  newPassword: string;
}

export interface CommonMethods {
  setStep: React.Dispatch<React.SetStateAction<LoginStepType>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface CheckSSOMethods extends CommonMethods {
  setSsoConfig: React.Dispatch<React.SetStateAction<SSOConfig | false>>;
}

export interface FetchTenantListMethods extends CommonMethods {
  setTenantList: React.Dispatch<React.SetStateAction<TenantWithSubdomain[]>>;
}

export interface AuthenticateMethods extends CommonMethods {
  setSecretCode: React.Dispatch<React.SetStateAction<string>>;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export interface AuthenticateMFAMethods {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export interface AuthenticatePasswordMethods extends AuthenticateMethods {

}

export const TENANT_INFO = 'tenantInfo';
export const SSO_CONFIG = 'ssoConfig';
export const AUTH_INFO = 'authInfo';

export interface TenantInfoInterface {
  lastTenant: string;
  tenantList: string[];
}

export const CHECK_SSO = 'CHECK_SSO';
export const FETCH_TENANT_LIST = 'FETCH_TENANT_LIST';
export const AUTHENTICATE = 'AUTHENTICATE';
export const AUTHENTICATE_MFA = 'AUTHENTICATE_MFA';
export const AUTHENTICATE_PASSWORD = 'AUTHENTICATE_PASSWORD';

export type AuthenticateHandlerOperation =
  | typeof CHECK_SSO
  | typeof FETCH_TENANT_LIST
  | typeof AUTHENTICATE
  | typeof AUTHENTICATE_MFA
  | typeof AUTHENTICATE_PASSWORD;
